module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-13-134dba1f544ac214aea0dddf25a9b026.jpg";